import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'areas-settings-page',
    templateUrl: './areas-settings.component.html',
    styleUrls: ['./areas-settings.component.scss'],
    standalone: false
})
export class AreasSettingsComponent implements OnInit
{
  data;
    constructor(private http: HttpClient)
    {
    }

  ngOnInit()
  {
  }
}
